'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import { useFetchPlayMissionListQuery } from '@module/queries/mission/missionQueryHooks';
import { Bang } from '@module/svg/icons';
import CloseButton from '@pc/components/atoms/button/CloseButton';
import ModalFooter from '@pc/components/modal/ModalFooter';
import ModalOverlay from '@pc/components/modal/ModalOverlay';
import { Modal } from '@pc/components/modal/modal';
import { MissionItem } from '@pc/components/play/mission/MissionItem';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { TooltipBox } from '@pc/components/tooltip/TooltipBox';
import { type Dispatch, type SetStateAction, useState } from 'react';
export default function ModalMissionChallenge(t0) {
  const $ = _c(41);
  const {
    userIdx,
    setOpen,
    missionRequestModal
  } = t0;
  const [order, setOrder] = useState("all");
  let t1;
  if ($[0] !== order || $[1] !== userIdx) {
    t1 = {
      bjUserIdx: userIdx,
      type: order
    };
    $[0] = order;
    $[1] = userIdx;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: missionData,
    refetch: refetchMissionList
  } = useFetchPlayMissionListQuery(t1);
  const t2 = !missionRequestModal;
  let t3;
  if ($[3] !== t2) {
    t3 = cn("h-[556px] w-[368px]", {
      "h-[520px]": t2
    });
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>미션 챌린지</div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-center">BJ와 함께하는 미션 챌린지 시간!{t5}최근 10일간 BJ에게 요청된 미션 목<br />록을 확인할 수 있습니다.</p>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-2">{t4}<TooltipBox content={t6}><div><Bang style={{
            fontSize: 16
          }} /></div></TooltipBox></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== setOpen) {
    t8 = <Modal.Header><Modal.Title className="flex justify-between">{t7}<CloseButton onClick={() => setOpen?.(false)} /></Modal.Title></Modal.Header>;
    $[9] = setOpen;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOrder("all");
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = order === "all";
  let t11;
  if ($[12] !== t10) {
    t11 = cn(" text-colorFg01", {
      "font-black": t10
    });
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <button onClick={t9} className={t11}>전체</button>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mx-[10px] inline-block h-[12px] w-[2px] bg-borderBg07" />;
    t14 = () => {
      setOrder("my");
    };
    $[16] = t13;
    $[17] = t14;
  } else {
    t13 = $[16];
    t14 = $[17];
  }
  const t15 = order === "my";
  let t16;
  if ($[18] !== t15) {
    t16 = cn("text-colorFg01", {
      "font-black": t15
    });
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t16) {
    t17 = <button onClick={t14} className={t16}>내가 등록한 미션</button>;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t12 || $[23] !== t17) {
    t18 = <div className="mb-[15px] flex items-center justify-end px-5 text-[14px]">{t12}{t13}{t17}</div>;
    $[22] = t12;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== missionData || $[26] !== missionRequestModal || $[27] !== refetchMissionList) {
    t19 = missionData && missionData?.list.length > 0 ? missionData?.list.map(el => <MissionItem key={el.idx} item={el} sponRestricted={!missionRequestModal} refetchMissionList={refetchMissionList} />) : <NotFoundDisplay text={"\uB4F1\uB85D\uB41C \uBBF8\uC158\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."} className="h-full" />;
    $[25] = missionData;
    $[26] = missionRequestModal;
    $[27] = refetchMissionList;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t19) {
    t20 = <div className="modal-scrollbar-custom h-[390px] overflow-y-auto px-4">{t19}</div>;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t18 || $[32] !== t20) {
    t21 = <Modal.Content className="p-0 pt-2"><div>{t18}{t20}</div></Modal.Content>;
    $[31] = t18;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== missionRequestModal) {
    t22 = missionRequestModal && <ModalFooter text={"\uBBF8\uC158 \uC694\uCCAD\uD558\uAE30"} onClick={missionRequestModal} />;
    $[34] = missionRequestModal;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t21 || $[37] !== t22 || $[38] !== t3 || $[39] !== t8) {
    t23 = <ModalOverlay><Modal.Container className={t3}>{t8}{t21}{t22}</Modal.Container></ModalOverlay>;
    $[36] = t21;
    $[37] = t22;
    $[38] = t3;
    $[39] = t8;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  return t23;
}